<script>
	import { step, user, setUserFromURL, TokenValid } from './store.js'
	import { onMount } from 'svelte'
	import Token from './pages/Token.svelte';
	import { TokenSubmit } from './service.js'
	import Register from './pages/Register.svelte';
	import NextSteps from './pages/NextSteps.svelte';
	import Splash from './sections/Splash.svelte';
	import BottomInformation from './sections/BottomInformation.svelte';

	let current_step;

	const unsubscribe = step.subscribe( value => {
		current_step = value
	})

	let ua = window.navigator.userAgent
	let msie = ua.indexOf('MSIE ') // IE 10 or older
	let trident = ua.indexOf('Trident/') //IE 11
	let isIE = msie > 0 || trident > 0
		
	onMount(setUserFromURL)

</script>
{#if isIE }
	<div class="ie-message">
		This browser is incompatible. In order to proceed, we suggest using Google Chrome, Mozilla Firefox, or Safari.
	</div>
{/if}
<main>
	<Splash />
	<section id="interaction">
		{#if current_step === 1}
			<Token />
			<BottomInformation />
		{:else if current_step === 2}
			<Register />
			<BottomInformation />
		{:else if current_step === 3}
			<NextSteps />
		{/if}
		<p>Questions?</p>
		<p>Contact customer support at</p>
		<p><a href="mailto:support@modum.io">support@modum.io</a></p>
	</section>
</main>

<style lang="scss">

@import './scss/variables.scss';

p {
	display: block;
	font-size: 14px;
	margin-top: 0;
	margin-bottom: 0;
}

#interaction {
	padding: 2em;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	.content {
		max-width: 400px;
	}
}

main {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
}

.ie-message {
	width: 100%;
	background-color: orange;
	padding: 10px;
	text-align: center;
}

@include large {
	#interaction {
		width: 65%;
	}
  main {
		flex-direction: row;
	}
}

@include mobile {
	main {
  	background: transparent linear-gradient(208deg, $marine 0%, $login_background_dark_blue 100%) 0% 0% no-repeat padding-box;
	}
	#interaction {
		background-color: #fff;
		margin: auto;
		width: calc( 100% - 40px);
		border-radius: 5px;
		margin-bottom: 60px;
	}
}
</style>
